import React from 'react'
import QuestionLanguageSelectorTab from './QuestionLanguageSelectorTab'
import TestLanguageSelectorTab from './TestLanguageSelectorTab'

const LanguageSelectorTab = ({ isTestSettings, ...props }) => {
  return isTestSettings ? (
    <TestLanguageSelectorTab {...props} />
  ) : (
    <QuestionLanguageSelectorTab {...props} />
  )
}

export default LanguageSelectorTab
